var bundleQty = 1;
var insertQty = 0;
var duvetQty = 0;
var hasDuvet = false;
var hasDuvetInsert = false;
var duvetVariants = [];
var insertVariants = [];
var bundleVariants = [];

function addQty(product) {
  if (product.product_type == "Duvets" && product.selected_variant.inventory_quantity - 1 >= product.quantity) {
    product.quantity += 1;
    duvetQty += 1;
  } else if (product.product_type == "Duvet Inserts" && product.selected_variant.inventory_quantity - 1 >= product.quantity) { 
    insertQty += 1;
    product.quantity += 1;
  } else {
    product.quantity += 1;
  }
}

function subQty(product) {
  if (product.product_type == "Duvets" && product.quantity > 0) { 
    duvetQty -= 1;
    product.quantity -= 1;
  } else if (product.product_type == "Duvet Inserts" && product.quantity > 0) {
    insertQty -= 1;
    product.quantity -= 1;
  } else {
    product.quantity -= 1;
  }
}

document.addEventListener('rebuy.ready', function(event){
const widget = window.Rebuy.widgets.find((w) => w.id === "69425");
widget.data.products[0].selected = false;
var widgetProducts = widget.data.products;

widgetProducts.forEach(product => {
  var totalQty = 0;
    product.variants.forEach(variant => {
        var variantObj = {};
        totalQty += variant.inventory_quantity;
        variantObj.title = variant.title;
        variantObj.quantity = variant.inventory_quantity;
        variantObj.id = variant.id;
        if (product.product_type == "Duvets" && variantObj.quantity > 0) {
          duvetVariants.push(variantObj);
        } else if (product.product_type == "Duvet Inserts" && variantObj.quantity > 0) {
          insertVariants.push(variantObj);
        }
    });

  if (product.product_type == "Duvets" && totalQty > 0) {
    duvetQty += product.quantity;
    hasDuvet = true;
  } else if  (product.product_type == "Duvet Inserts" && totalQty > 0)  {
    insertQty += product.quantity;
    hasDuvetInsert = true;
  }

  if (totalQty < 1) {
    product.selected = false;
    product.quantity = 0;
    product.stock = false;
  } else {
    product.stock = true;
  }
});

if (hasDuvet == false || hasDuvetInsert == false) {
  widgetProducts.forEach(product => {
    product.selected == false;
    product.quantity == 0;
    document.querySelector(".addtocart").disabled = true;
  });
}
});